import { Flex, HStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { CandidateListTypeDropdown } from '@/components';
import { type CandidateListType } from '@/services/api';

import { AddSurveyParticipant } from './AddSurveyParticipant';

interface HeaderSectionProps {
  totalParticipants: number | string;
  surveyId?: string;
  candidateListType: CandidateListType;
  setCandidateListType: (value: CandidateListType) => void;
}

export const SurveyParticipantsListHeaderSection: React.FC<
  HeaderSectionProps
> = ({
  totalParticipants,
  surveyId,
  candidateListType,
  setCandidateListType,
}) => {
  const { t } = useTranslation(['common', 'survey']);

  return (
    <>
      <Flex align="center" py="20px" px="24px" justify="space-between">
        <Flex gap={3} align="center">
          <CandidateListTypeDropdown
            selectedListType={candidateListType}
            onListTypeChange={setCandidateListType}
          >
            {`${t('survey:participants')} (${totalParticipants})`}
          </CandidateListTypeDropdown>
        </Flex>

        <HStack rowGap={3}>
          {surveyId ? <AddSurveyParticipant surveyId={surveyId} /> : null}
        </HStack>
      </Flex>
    </>
  );
};
